const initials = "featured/";
export const UPDATE_FEATURED_PRODUCTS = `${initials}UPDATE_FEATURED_PRODUCTS`;
